import { css } from 'lit';

export const style = css`
:host {
    --tab__color: var(--_tab__color, var(--sbkTabColorFgColorOnLightEnabled));
    --tab__color--hover: var(--_tab__color--hover, var(--sbkTabColorFgColorOnLightHover));
    --tab__color--active: var(--_tab__color--active, var(--sbkTabColorFgColorOnLightActive));
    --tab__br--focus: var(--_tab__br--focus, var(--sbkTabBorderOnLightFocus));
  }

    * {
        box-sizing: border-box;
    }

  .tab-item {
    background-color: unset;
    display: block;
    outline: 2px solid transparent;
    outline-offset: var(--sbkTabBorderGapFocus);
    border-radius: var(--sbkTabBorderRadiusFocus);
    border: none;
    cursor: pointer;
    text-decoration: none;
    color: var(--tab__color);
    position: relative;
      padding: 0;
    white-space: nowrap;
    text-align: left;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
          color: var(--tab__color--hover);
      }
    }

    &:focus-visible {
      outline: var(--tab__br--focus);
    }
  }

  .tab-item--active {
    color: var(--tab__color--active);

    .tab-item__border:after {
        background: var(--tab__color--active);
    }
  }

  .tab-item__border {
    &:after {
      content:"";
      display: block;
      background: transparent;
      width: 100%;
      height: var(--sbkTabSizingBorderHeight);
      border-radius: var(--sbkTabBorderRadiusSelected);
      margin-top: var(--sbkTabSpacing2xs);
    }
  }


  .tab-item--large {
    font: var(--sbkTabTypographyLargeLabel);
  }

  .tab-item--medium {
    font: var(--sbkTabTypographyMediumLabel);
  }

  .tab-item--small {
    font: var(--sbkTabTypographySmallLabel);
  }

  .tab-item--extra-small {
    font: var(--sbkTabTypographyExtraSmallLabel);
  }


`;
